<style>
    .table-striped-double {
        background-color: #f2f6fa;
    }

    .table-striped-double tr:nth-child(4n+1), .table-striped-double tr:nth-child(4n+2) {
        background-color: #ebf1f5;
    }

    .button-selected {
        color: #333;
        background-color: #e6e6e6;
        border-color: #8c8c8c;
        outline: 5px auto -webkit-focus-ring-color;
        outline-offset: -2px;
    }
</style>
<div>
    <div class="row" style="margin-left: 0; padding-top: 10px; margin-bottom: -10px; margin-right: 0;">
        <div class="col-md-12">
            <a routerLink="/beach/submission/list"> < Back to list</a>
        </div>
    </div>
    <div style="padding: 35vh 44vw;" *ngIf="SubmissionsService.loading">
        <i class="fa fa-spinner fa-pulse fa-3x"></i>
    </div>
    <div class="row" style="margin:10px 0px;" *ngIf="!SubmissionsService.loading">
        <div class="col-md-12" *ngIf="SubmissionsService.currentSubmission.globalid !== undefined">
            <div class="panel panel-default" style="margin-top:10px;">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        Submission Details
                    </h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-md-6">
                            <b>Created
                                Date:</b> {{ SubmissionsService.currentSubmission.created_date | date:'short' }}<br/>
                            <b>Last Submission
                                Date:</b> {{ SubmissionsService.currentSubmission.date | date:'short' }}<br/>
<!--                     todo:       <b>Submission-->
<!--                                Content:</b> {{ SubmissionsService.currentSubmission.submission_content | display:SubmissionsService.currentSubmission.meta.fields.submission_content.choices }}<br/>-->
                            <b>Submission Status:</b> {{ SubmissionsService.currentSubmission.status }}<br/>
                            <b>Submission Status
                                Description:</b> {{ SubmissionsService.currentSubmission.statusDescription }}<br/>
                        </div>
                        <div class="col-md-6">
                            <b>Start Date:</b> {{ SubmissionsService.currentSubmission.start_date | date:'short' }}<br/>
                            <b>End Date:</b> {{ SubmissionsService.currentSubmission.end_date | date:'short' }}<br/>
                            <b>
                                {{ SubmissionsService.currentSubmission.submission_content == 'notif' ? 'Advisory' : 'Activity' }}
                                Count:</b> {{ SubmissionsService.currentSubmission.count }}<br/>
                            <span *ngIf="SubmissionsService.currentSubmission.submission_content == 'monitor'">
                                 <b>Result Count:</b> {{ SubmissionsService.currentSubmission.result_count }}<br/>

                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="panel panel-default" style="margin-top:10px;"
                 *ngIf="SubmissionsService.currentSubmission.globalid === undefined">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        Step #1: What type of data do you want to submit?
                    </h4>
                </div>
                <div class="panel-body text-center">
                    <button class="btn btn-default"
                            [class]="SubmissionsService.currentSubmission.submission_content === 'notif' ? 'button-selected' : ''"
                            (click)="saveSubmission('notif')">
                        Notification
                    </button>
                    <button class="btn btn-default"
                            [class]="SubmissionsService.currentSubmission.submission_content === 'monitor' ? 'button-selected' : ''"
                            (click)="saveSubmission('monitor')">
                        Monitoring
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="panel panel-default" style="margin-top:10px;"
                 *ngIf="SubmissionsService.currentSubmission.globalid === undefined">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        Step #2: What type of submissions?
                    </h4>
                </div>
                <div class="panel-body text-center">
                    <button class="btn btn-default"
                            [class]="SubmissionsService.currentSubmission.submissiontype === 'Update-Insert' ? 'button-selected' : ''"
                            (click)="saveSubmission('Update-Insert')">
                        Update/Insert
                    </button>
                    <button class="btn btn-default"
                            [class]="SubmissionsService.currentSubmission.submissiontype === 'Delete' ? 'button-selected' : ''"
                            (click)="saveSubmission('Delete')">Delete
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="panel panel-default" style="margin-top:10px;"
                 *ngIf="SubmissionsService.currentSubmission.submissiontype !== undefined && SubmissionsService.currentSubmission.globalid === undefined">
                <div class="panel-heading">
                    <div class="panel-title">
                        Step #3: Do you want to automatically get data by date or manually build submission?
                    </div>
                </div>
                <div class="panel-body text-center">
                    <button class="btn btn-default" *ngIf="!SubmissionsService.currentSubmission.saving"
                            (click)="SubmissionsService.createSubmission('auto')">Auto
                    </button>
                    <button class="btn btn-default" *ngIf="!SubmissionsService.currentSubmission.saving"
                            (click)="SubmissionsService.createSubmission('manual')">Manual
                    </button>
                    <button class="btn btn-default" *ngIf="SubmissionsService.currentSubmission.saving">
                        <i class="fa fa-pulse fa-spinner"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin:10px 0px;" *ngIf="SubmissionsService.currentSubmission.globalid">
        <div class="col-md-12">
            <div class="panel panel-default" style="margin-top:10px;">
                <div class="panel-heading">
                    <div class="panel-title">
                        Step #4: Review/Edit submission content.
                    </div>
                </div>
                <div class="panel-body">
                    <span *ngIf="SubmissionsService.loadingContent"><i class="fa fa-spinner fa-pulse"></i> </span>
                    <span *ngIf="!SubmissionsService.loadingContent">
                        <app-submission-inline [meta]="SubmissionsService.currentSubmission.locations.meta"
                                          [id]="id" [hasPermission]="true"
                                           *ngIf="SubmissionsService.currentSubmission.submission_content === 'monitor'"
                                           [items]="SubmissionsService.currentSubmission.locations">
                        </app-submission-inline>
                        <app-submission-inline [meta]="SubmissionsService.currentSubmission.activities.meta"
                                           [id]="id" [hasPermission]="true"
                                           *ngIf="SubmissionsService.currentSubmission.submission_content === 'monitor' &&
                                                  SubmissionsService.currentSubmission.activities.meta !== undefined"
                                           [items]="SubmissionsService.currentSubmission.activities">
                        </app-submission-inline>
                        <app-submission-inline [meta]="SubmissionsService.currentSubmission.beaches.meta" [id]="id"
                                           *ngIf="SubmissionsService.currentSubmission.submission_content === 'notif'"
                                           [items]="SubmissionsService.currentSubmission.beaches" [hasPermission]="true">
                        </app-submission-inline>
                        </span>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin:10px 0px;"
         *ngIf="!SubmissionsService.currentSubmission.globalid === undefined || SubmissionsService.currentSubmission.submission_content === 'monitor'">
        <div class="col-md-12">
            <div class="panel panel-default" style="margin-top:10px;">
                <div class="panel-heading">
                    <h4 class="panel-title">Step #4: If end of year indicate data complete.</h4>
                </div>
                <div class="panel-body text-center row">
                    <div class="col-md-3">
                        <label for="notifComplete">Notification Data Complete:</label>
                        <input [(ngModel)]="SubmissionsService.currentSubmission.notificationdatacompletionind"
                               id="notifComplete" type="checkbox"/>
                    </div>
                    <div class="col-md-3">
                        <label for="monitorComplete">Monitoring Data Complete:</label>
                        <input [(ngModel)]="SubmissionsService.currentSubmission.monitoringdatacompletionind"
                               id="monitorComplete" type="checkbox"/>
                    </div>
                    <div class="col-md-3">
                        <label for="locationComplete">Location Data Complete:</label>
                        <input [(ngModel)]="SubmissionsService.currentSubmission.locationdatacompletionind"
                               id="locationComplete" type="checkbox"/>
                    </div>
                    <div class="col-md-3">
                        <label for="yearComplete">Year:</label>
                        <input [(ngModel)]="SubmissionsService.currentSubmission.completionyear"
                               id="yearComplete" type="text"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin:10px 0px;"
         *ngIf="SubmissionsService.currentSubmission.globalid || !SubmissionsService.loadingContent">
        <div class="col-md-12">
            <div class="panel panel-default" style="margin-top:10px;">
                <div class="panel-heading">
                    <h4 class="panel-title">Step
                        <span *ngIf="SubmissionsService.currentSubmission.submission_content === 'monitor'">#5</span>
                        <span *ngIf="SubmissionsService.currentSubmission.submission_content === 'notif'">#6</span>
                        : Enter CDX credentials.</h4>
                </div>
                <div class="panel-body text-center row">
                    <div class="col-md-3">
                        <label for="cdxUsername">Username:</label>
                        <input [(ngModel)]="SubmissionsService.user.email" id="cdxUsername" type="text"/>
                    </div>
                    <div class="col-md-3">
                        <label for="cdxPassword">Password:</label>
                        <input [(ngModel)]="SubmissionsService.user.password" id="cdxPassword" type="password"/>
                    </div>
                    <div class="col-md-3">
                        <div class="btn btn-primary" style="cursor: none;" *ngIf="SubmissionsService.submitting">
                            <i class="fa fa-spinner fa-pulse"></i>
                        </div>
                        <button class="btn btn-primary" (click)="SubmissionsService.submitSubmission()"
                                *ngIf="(SubmissionsService.currentSubmission.status === 'Not Submitted' ||
                                    SubmissionsService.currentSubmission.status === 'Failed') &&
                                    !SubmissionsService.submitting">Submit
                        </button>
                        <button class="btn btn-primary" (click)="SubmissionsService.updateSubmission()"
                                *ngIf="(SubmissionsService.currentSubmission.status === 'Processing' ||
                                SubmissionsService.currentSubmission.status === 'Pending')
                                    && !SubmissionsService.submitting">Update Status
                        </button>
                        <button class="btn btn-primary" (click)="SubmissionsService.getSubmissionReport()"
                                *ngIf="SubmissionsService.currentSubmission.status === 'Failed'">Get Report
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--<script type="text/ng-template" id="warningModal.html">-->
<!--    <div class="modal-header">-->
<!--        <h4 class="modal-title" id="myModalLabel">Danger!</h4>-->
<!--    </div>-->
<!--    <div class="modal-body">-->
<!--        By selecting this you will reload all of the activities and any unsaved changes will be lost.-->
<!--    </div>-->
<!--    <div class="modal-footer">-->
<!--        <button type="button" class="btn btn-warning" (click)="ok()">Ok</button>-->
<!--        <button type="button" class="btn btn-primary" (click)="cancel()">Cancel</button>-->
<!--    </div>-->
<!--</script>-->
